import logo from './logo.svg';
import React, { useState, useEffect } from 'react';
import './App.css';
import PrivateRoute from './utils/PrivateRoute';
import PublicRoute from './utils/PublicRoute';
import { getToken, removeUserSession, setUserSession } from './utils/Common';
import { Container,  Content, Sidebar } from 'rsuite';

import CUSTFooter from './component/CUSTFooter';
import CUSTHeader from './component/CUSTHeader';
import CUSTRoutes from './component/CUSTRoutes';


function App() {

  return (
    <div className="App">
      <div class="main-container">
      <CUSTHeader></CUSTHeader>
      <section>
      <Content className="section_padding">
      <CUSTRoutes></CUSTRoutes>
      </Content>
      </section>
      <footer>
       <CUSTFooter></CUSTFooter>
      </footer>
      </div>
     
      
    </div>
  );
}

export default App;
